// REST
import { RepositoryFactory } from "../../repository/RepositoryFactory";
const ApiRepository = RepositoryFactory.get("api");

// TODO util
import liff from "@line/liff";
const getLineToken = () => {
  return liff.getIDToken();
};

const getDefaultState = () => ({
  cartCheckResult: null,
  cartMenuIds: [],
  userOrderStatus: null,
  settings: null,
});

// debug
// const sleep = async (msec) => {
//   return new Promise(function (resolve) {
//     setTimeout(resolve, msec);
//   });
// };

export default {
  namespaced: true,
  state: getDefaultState(),
  mutations: {
    cartCheckResult (state, val) { state.cartCheckResult = val; },
    cartMenuIds (state, val) { state.cartMenuIds = val; },
    userOrderStatus (state, val) { state.userOrderStatus = val; },
    settings (state, val) { state.settings = val; },
  },
  getters: {
    cartCheckResult: (state) => state.cartCheckResult,
    cartMenuIds: (state) => state.cartMenuIds,
    userOrderStatus: (state) => state.userOrderStatus,
    settings: (state) => state.settings,
  },
  actions: {
    //===================================
    // 共通
    //===================================
    /**
     * headers 作成 (LINE, Firebase Auth 両方)
     * @param {*} context 
     * @returns 
     */
    async createAuthHeaders (context) {
      const shopId = context.rootGetters.shopId;
      const lineToken = getLineToken();
      console.log("createAuthHeaders", shopId, lineToken);
      return {
        lineToken: lineToken,
      };
    },
    //===================================
    // REST
    //===================================
    /**
     * サービス稼働中かどうか
     * @returns
     */
    async isServiceStatusActive (context) {
      try {
        const shopId = context.rootGetters.shopId;
        if (!shopId) {
          throw new Error("shopId is empty");
        }

        const res = await ApiRepository.isServiceStatusActive(shopId);
        console.log(`res=${JSON.stringify(res)}`);
        const active = res.data.data;
        console.log(`active`, active);
        return active;
      } catch (error) {
        console.log(error);
        throw error;
      }
    },
    /**
     * 受取時間関係設定 取得
     * @returns 
     */
    async getReceivableSetting (context) {
      try {
        this.commit("rest/settings", null, { root: true });
        const shopId = context.rootGetters.shopId;
        if (!shopId) {
          throw new Error("shopId is empty");
        }

        const headers = {};
        const res = await ApiRepository.getReceivableSetting(shopId, headers);
        // console.log(`res=${JSON.stringify(res)}`);
        const settings = res.data.data;
        console.log(`settings`, settings);
        this.commit("rest/settings", settings, { root: true });
        return settings;
      } catch (error) {
        console.log(error);
        throw error;
      }
    },
    /**
     * 受取日時チェック
     * @param {*} context
     * @param {*} visitTimeYMD
     * @param {*} visitTimeHHMM
     * @returns
     */
    async validateVisitTime (context, { visitTimeYMD, visitTimeHHMM }) {
      try {
        const shopId = context.rootGetters.shopId;
        if (!shopId) {
          throw new Error("shopId is empty");
        }

        const headers = {};
        const params = {
          visitTimeYMD: visitTimeYMD,
          visitTimeHHMM: visitTimeHHMM,
        };
        const res = await ApiRepository.validateVisitTime(shopId, headers, params);
        // console.log(`res=${JSON.stringify(res)}`);
        return res.data.data;
      } catch (error) {
        console.log(error);
        throw error;
      }
    },
    /**
     * 注文受付状態 取得
     * @returns
     */
    async getOrderAcceptStatus (context) {
      try {
        const shopId = context.rootGetters.shopId;
        if (!shopId) {
          throw new Error("shopId is empty");
        }

        const settings = await this.dispatch("rest/getReceivableSetting", { shopId });
        const orderAcceptStatus = settings.orderAcceptStatus;
        return orderAcceptStatus;
      } catch (error) {
        console.log(error);
        throw error;
      }
    },
    /**
     * ユーザ注文状態(直近1件) 取得
     * @param {*} context
     * @returns
     */
    async getUserOrderStatusRecent (context) {
      try {
        this.commit("rest/userOrderStatus", null, { root: true });
        const shopId = context.rootGetters.shopId;
        if (!shopId) {
          throw new Error("shopId is empty");
        }
        const headers = await this.dispatch("rest/createAuthHeaders");
        const res = await ApiRepository.getUserOrderStatusRecent(shopId, headers);
        // console.log(`res=${JSON.stringify(res)}`);
        // return res.data.data;
        const userOrderStatus = res.data.data;
        console.log(`userOrderStatus`, userOrderStatus);
        this.commit("rest/userOrderStatus", userOrderStatus, { root: true });
        return userOrderStatus;
      } catch (error) {
        console.log(error);
        throw error;
      }
    },
    /**
     * 注文が通っているかどうか
     */
    async isOrderPassed (context, { queryCartId }) {
      try {
        const shopId = context.rootGetters.shopId;
        if (!shopId) {
          throw new Error("shopId is empty");
        }
        const headers = await this.dispatch("rest/createAuthHeaders");
        const params = { orderCartId: queryCartId }
        const res = await ApiRepository.isOrderPassed(shopId, headers, params);
        console.log(`res=${JSON.stringify(res)}`);
        return res.data.data;
      } catch (error) {
        console.log(error);
        throw error;
      }
    },
    /**
     * カート内アイテムチェック
     * @returns 
     */
    async checkItemsInCart (context) {
      try {
        this.commit("rest/cartCheckResult", null, { root: true });
        this.commit("rest/cartMenuIds", [], { root: true });
        const shopId = context.rootGetters.shopId;
        if (!shopId) {
          throw new Error("shopId is empty");
        }
        const headers = await this.dispatch("rest/createAuthHeaders");
        const res = await ApiRepository.checkItemsInCart(shopId, headers);
        // console.log(`res=${JSON.stringify(res)}`);

        const cartCheckResult = res.data.data.result.judge;
        const cartMenuIds = res.data.data.result.cartMenuIds ?? [];
        // console.log(`@checkItemsInCart`, cartCheckResult, cartMenuIds);
        this.commit("rest/cartCheckResult", cartCheckResult, { root: true });
        this.commit("rest/cartMenuIds", cartMenuIds, { root: true });
        return cartCheckResult;
      } catch (error) {
        console.log(error);
        throw error;
      }
    },
    /**
     * カートID 更新
     */
    async updateCartId (context,) {
      try {
        const shopId = context.rootGetters.shopId;
        if (!shopId) {
          throw new Error("shopId is empty");
        }
        const headers = await this.dispatch("rest/createAuthHeaders");
        const res = await ApiRepository.updateCartId(shopId, headers);
        const result = res.data.data;
        return result;
      } catch (error) {
        console.log(error);
        throw error;
      }
    },
    /**
     * カート 注文方法 更新
     */
    async updateCartOrderWay (context, { orderStepData }) {
      try {
        const shopId = context.rootGetters.shopId;
        if (!shopId) {
          throw new Error("shopId is empty");
        }
        const headers = await this.dispatch("rest/createAuthHeaders");
        const params = {
          orderWay: orderStepData,
        }
        const res = await ApiRepository.updateCartOrderWay(shopId, headers, params);
        const result = res.data.data;
        return result;
      } catch (error) {
        console.log(error);
        throw error;
      }
    },
    async fetchCartData (context) {
      try {
        const shopId = context.rootGetters.shopId;
        if (!shopId) {
          throw new Error("shopId is empty");
        }
        const headers = await this.dispatch("rest/createAuthHeaders");
        const res = await ApiRepository.getCartData(shopId, headers);
        console.log(`res=${JSON.stringify(res)}`);
        return res.data.data.cart;
      } catch (error) {
        console.log(error);
        throw error;
      }
    },
    /**
     * カートメニュー 追加
     */
    async addCartMenu (context, { menu }) {
      try {
        const shopId = context.rootGetters.shopId;
        if (!shopId) {
          throw new Error("shopId is empty");
        }
        const headers = await this.dispatch("rest/createAuthHeaders");
        const params = {
          menu,
        };
        const res = await ApiRepository.addCartMenu(shopId, headers, params);
        const result = res.data.data;
        return result;
      } catch (error) {
        console.log(error);
        throw error;
      }
    },
    /**
     * カートメニュー 編集
     */
    async editCartMenu (context, { menu }) {
      try {
        const shopId = context.rootGetters.shopId;
        if (!shopId) {
          throw new Error("shopId is empty");
        }
        const headers = await this.dispatch("rest/createAuthHeaders");
        const params = {
          cartMenuId: menu.cartMenuId,
          menu,
        };
        const res = await ApiRepository.editCartMenu(shopId, headers, params);
        const result = res.data.data;
        return result;
      } catch (error) {
        console.log(error);
        throw error;
      }
    },
    /**
     * カートメニュー 削除
     */
    async deleteCartMenu (context, { menu }) {
      try {
        const shopId = context.rootGetters.shopId;
        if (!shopId) {
          throw new Error("shopId is empty");
        }
        const headers = await this.dispatch("rest/createAuthHeaders");
        const params = {
          cartMenuId: menu.cartMenuId,
        };
        const res = await ApiRepository.deleteCartMenu(shopId, headers, params);
        const result = res.data.data;
        return result;
      } catch (error) {
        console.log(error);
        throw error;
      }
    },
    /**
     * カートメニュー 削除 (master 変更時のカートクリア処理)
     */
    async deleteCartMenusByMstChanged (context) {
      try {
        const shopId = context.rootGetters.shopId;
        if (!shopId) {
          throw new Error("shopId is empty");
        }
        const cartMenuIds = context.getters.cartMenuIds;
        console.log("@cartMenuIds", cartMenuIds);
        if (!cartMenuIds || cartMenuIds.length == 0) {
          console.log("do nothing: cartMenuIds is empty");
          return;
        }

        const headers = await this.dispatch("rest/createAuthHeaders");
        const tasks = cartMenuIds.map(cartMenuId => {
          const params = { cartMenuId };
          return ApiRepository.deleteCartMenu(shopId, headers, params);
        });
        await Promise.all(tasks);
      } catch (error) {
        console.log(error);
        throw error;
      }
    },
    /**
     * カートメニュー詳細 取得
     */
    async fetchMenuForCart (context, { cartMenuId }) {
      try {
        this.commit("menu", null, { root: true });
        const shopId = context.rootGetters.shopId;
        if (!shopId) {
          throw new Error("shopId is empty");
        }
        const headers = await this.dispatch("rest/createAuthHeaders");
        const params = { cartMenuId }
        const res = await ApiRepository.getCartMenu(shopId, headers, params);
        const menu = res.data.data;
        console.log(`menu`, menu);
        this.commit("menu", menu, { root: true });
        return menu;
      } catch (error) {
        console.log(error);
        throw error;
      }
    },
    /**
     * 注文履歴(一覧) 取得
     */
    async fetchHistoryOrders (context) {
      try {
        this.commit("historyOrders", null, { root: true });
        const shopId = context.rootGetters.shopId;
        if (!shopId) {
          throw new Error("shopId is empty");
        }
        const headers = await this.dispatch("rest/createAuthHeaders");
        const res = await ApiRepository.getHistoryOrders(shopId, headers);
        const orders = res.data.data;
        console.log(`orders`, orders);
        this.commit("historyOrders", orders, { root: true });
        return orders;
      } catch (error) {
        console.log(error);
        throw error;
      }
    },
    /**
     * 注文履歴(詳細) 取得
     */
    async fetchHistoryOrder (context, { orderId }) {
      try {
        const shopId = context.rootGetters.shopId;
        if (!shopId) {
          throw new Error("shopId is empty");
        }
        const headers = await this.dispatch("rest/createAuthHeaders");
        const params = { orderId }
        const res = await ApiRepository.getHistoryOrder(shopId, headers, params);
        const order = res.data.data;
        console.log(`order`, order);
        return order;
      } catch (error) {
        console.log(error);
        throw error;
      }
    },
    /**
     * 注文履歴(カートID) 取得
     */
    async fetchHistoryOrderByCartId (context, { cartId }) {
      try {
        const shopId = context.rootGetters.shopId;
        if (!shopId) {
          throw new Error("shopId is empty");
        }
        const headers = await this.dispatch("rest/createAuthHeaders");
        const params = { cartId }
        const res = await ApiRepository.getHistoryOrderByCartId(shopId, headers, params);
        const order = res.data.data;
        console.log(`order`, order);
        return order;
      } catch (error) {
        console.log(error);
        throw error;
      }
    },
    /**
     * 注文履歴 メニュー 取得
     */
    async fetchMenuForHistory (context, { orderId, orderMenuId }) {
      try {
        this.commit("menu", null, { root: true });
        const shopId = context.rootGetters.shopId;
        if (!shopId) {
          throw new Error("shopId is empty");
        }
        const headers = await this.dispatch("rest/createAuthHeaders");
        const params = { orderId, orderMenuId }
        const res = await ApiRepository.getHistoryMenu(shopId, headers, params);
        const menu = res.data.data;
        console.log(`menu`, menu);
        this.commit("menu", menu, { root: true });
        return menu;
      } catch (error) {
        console.log(error);
        throw error;
      }
    },

    /**
     * 予約 (後払い)
     */
    async payAfter (context, { liffAccessToken }) {
      try {
        const shopId = context.rootGetters.shopId;
        if (!shopId) {
          throw new Error("shopId is empty");
        }
        const userId = context.rootGetters.userId;
        if (!userId) {
          throw new Error("userId is empty");
        }

        const params = {
          shopId,
          userId,
          liffAccessToken
        }
        console.log("params", params)

        const headers = await this.dispatch("rest/createAuthHeaders");
        const res = await ApiRepository.payAfter(shopId, headers, params);
        console.log(`res=${JSON.stringify(res)}`);
        return res.data.data;
      } catch (error) {
        console.log(error);
        throw error;
      }
    },
  },
}
